import { createFileRoute } from "@tanstack/react-router";
import HelpHeader from "@/components/Help/HelpHeader";
import HelpSections from "@/components/Help/HelpSections";
import Page from "@/components/Page";

function Help() {
  return (
    <Page
      banner={<HelpHeader />}
      contentPadding
      maxWidth="xl"
      sx={{
        backgroundColor: (theme) => theme.vars.palette.background["default"],
      }}
    >
      <HelpSections />
    </Page>
  );
}

export const Route = createFileRoute("/_auth/hjelp")({
  component: Help,
});
